
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...wordpressScenarioChooserFR]",
      function () {
        return require("private-next-pages/[...wordpressScenarioChooserFR].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...wordpressScenarioChooserFR]"])
      });
    }
  